import PropTypes from 'prop-types'
import {
  Loader,
  LoaderWrapper
} from '../../../components/page-loader/styled-components'
import { useIsLoggedIn } from '../../../zustand/authentication/use-auth-store'
import Login from '..'

const ForceLogin = ({ children }) => {
  const isLoggedIn = useIsLoggedIn()

  const dtToken = localStorage.getItem('dtToken')

  if (!isLoggedIn && !!dtToken) {
    // not logged in, but dtToken is available
    return (
      <LoaderWrapper>
        <Loader className="loader" />
      </LoaderWrapper>
    )
  }
  if (isLoggedIn) {
    return <>{children}</>
  }

  const pathName = window.location.pathname

  if (pathName !== '/') {
    localStorage.setItem('redirectTo', pathName)
  }

  return <Login />
}

ForceLogin.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
}

export default ForceLogin
